import React from "react";
import "../../containers/ConfirmOpenTicket.css";
import { IconContext } from "react-icons";
import { MdPerson } from "react-icons/md";
import { MdDirectionsCar } from "react-icons/md";
import { translations } from "../../containers/assets/translations";

export default class FetchItineraries extends React.Component {
	
  render() {
	  
    return (
	
      <div>
	  
        {this.props.displayItineraries ? (
          <div>
            <div className="col-md-12 Header">
              {translations[this.props.lang]["Select Itinerary"]}
            </div>
            <div className="col-md-12 head">
              <div className="col-md-3">
                {translations[this.props.lang]["Company"]} /
                {translations[this.props.lang]["Vessel"]}
              </div>
              <div className="col-md-2">
                {translations[this.props.lang]["Arrival Port"]}
              </div>
              <div className="col-md-3">
                {translations[this.props.lang]["Departure"]} (
                {translations[this.props.lang]["Date"]} -
                {translations[this.props.lang]["Time"]})
              </div>
              <div className="col-md-3">
                {translations[this.props.lang]["Arrival"]} (
                {translations[this.props.lang]["Date"]} -
                {translations[this.props.lang]["Time"]})
              </div>
              <div className="col-md-1">
                {translations[this.props.lang]["Availability"]}
              </div>
            </div>
            <div className="scrollbar style-1">
              <div className="force-overflow">
                {this.props.itineraries.map((post, index) => {
                  let className =
                    this.props.selectedItineraryIndex === index
                      ? "col-md-12 col-xs-12 selectedItinerary"
                      : "col-md-12 col-xs-12 resultsR";
                  return (
                    <div
                      className={className}
                      id={
                        post.ItineraryID +
                        "@" +
                        post.SailID +
                        "@" +
                        post.CompanyCode
                      }
                      key={post.ItineraryID}
                      onClick={event => {
                        this.props.handleClickOnItinerary(event, index);
                      }}
                    >
                      <div
                        className="col-md-3 col-sm-6 col-xs-6 resultcol"
                        id={
                          post.ItineraryID +
                          "@" +
                          post.SailID +
                          "@" +
                          post.CompanyCode
                        }
                      >
                        <span className="rowdescr">
                          {translations[this.props.lang]["Company"]} /
                          {translations[this.props.lang]["Vessel"]}:
                        </span>
                        {post.CompanyDescription} / {post.VesselName}
                      </div>
                      <div
                        id={
                          post.ItineraryID +
                          "@" +
                          post.SailID +
                          "@" +
                          post.CompanyCode
                        }
                        className="col-md-2 col-sm-6 col-xs-6 resultcol"
                      >
                        <span className="rowdescr">
                          {translations[this.props.lang]["Arrival Port"]}:
                        </span>
                        {post.ArrivalPortDescription}
                      </div>
                      <div
                        id={
                          post.ItineraryID +
                          "@" +
                          post.SailID +
                          "@" +
                          post.CompanyCode
                        }
                        className="col-md-3 col-sm-6 col-xs-6 resultcol"
                      >
                        <span className="rowdescr">
                          {translations[this.props.lang]["Departure"]}:
                        </span>
                        {post.DepartureDate.substr(-2)}/
                        {post.DepartureDate.substr(-4, 2)}/
                        {post.DepartureDate.substr(0, 4)}
                        {" - "}
                        {post.DepartureTime.substr(0, 2)}:
                        {post.DepartureTime.substr(2, 2)}
                      </div>
                      <div
                        className="col-md-3 col-sm-6 col-xs-6 resultcol"
                        id={
                          post.ItineraryID +
                          "@" +
                          post.SailID +
                          "@" +
                          post.CompanyCode
                        }
                      >
                        <span className="rowdescr">
                          {translations[this.props.lang]["Arrival"]}:
                        </span>
                        {post.ArrivalDate.substr(-2)}/
                        {post.ArrivalDate.substr(-4, 2)}/
                        {post.ArrivalDate.substr(0, 4)} {" - "}
                        {post.ArrivalTime.substr(0, 2)}:
                        {post.ArrivalTime.substr(2, 2)}
                      </div>
                      <div
                        className="col-md-1 col-sm-6 col-xs-6 resultcol"
                        id={
                          post.ItineraryID +
                          "@" +
                          post.SailID +
                          "@" +
                          post.CompanyCode
                        } //bb2429 red, #007f00 green, ece188 yellow
                      >
                        { post.PaxAvailabilityStatusColor==="g" ?(
                          <IconContext.Provider
                            value={{
                              color: "#007f00",
                              size: "2em"
                            }}
                          >
                            <MdPerson />
                          </IconContext.Provider>
                        ) : (null)}
                        {  post.PaxAvailabilityStatusColor==="r"?
                          (
                          <IconContext.Provider
                            value={{
                              color: "#bb2429",
                              size: "2em"
                            }}
                          >
                            <MdPerson />
                          </IconContext.Provider>
                        ) : (null)}
                        { post.PaxAvailabilityStatusColor==="y"? (
                          <IconContext.Provider
                            value={{
                              color: "#ece188",
                              size: "2em"
                            }}
                          >
                            <MdPerson />
                          </IconContext.Provider>
                        ) : (null)}
                        {post.VehAvailabilityStatusColor==="g" ? (
                          <IconContext.Provider
                            value={{
                              color: "#007f00",
                              size: "2em"
                            }}
                          >
                            <MdDirectionsCar />
                          </IconContext.Provider>
                        ) : (null)}
                        {post.PaxAvailabilityStatusColor==="r" ? (
                          <IconContext.Provider
                            value={{
                              color: "#bb2429",
                              size: "2em"
                            }}
                          >
                            <MdDirectionsCar />
                          </IconContext.Provider>
                        ) : (null)}
                        {post.ConfirmedVehicleRemaining==="y" ? (
                          <IconContext.Provider
                            value={{
                              color: "#ece188",
                              size: "2em"
                            }}
                          >
                            <MdDirectionsCar />
                          </IconContext.Provider>
                        ) : (null)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/confirmOpenTicketComponents/FetchItineraries.js